// importing data (skills, projects)
import { mySkills, projects } from "./data";


// Skill progressbar
const Skill = ({ skill, progress }) => {
    return <>
        <div className='skill'>
            <p>{skill}</p>
            <span>
                <span style={{width: progress + '%'}}></span>
            </span>
            <small>{ progress }%</small>
        </div>
    </>
}

// project component
const Project = ({name, gitHubLink, link, img}) => {
    return <>
        <div className='project' title={name}>
            <a href={link} className='img' target='_blank'>
                <img
                    src={require(`./images/${img}`)}
                    alt={name}
                    loading="lazy"
                />
            </a>
            <div>
                <p>{name}</p>
                {gitHubLink !== "" ? 
                <a href={gitHubLink} target='_blank'>Source Code</a>
                    :
                <span >No Source Code</span>    
                }
            </div>
        </div>
    </>
}

const Projects = () => {
    const renderSkills = mySkills
    .sort((a, b) => a.progress - b.progress)
    .reverse()
    .map((obj, index) => {
        return <Skill skill={obj.name} progress={obj.progress} key={index} id={`${index}`}/>
    });

    const renderProjects = projects.map((obj, index) => {
        return <Project key={index} name={obj.name} img={obj.img} link={obj.link} gitHubLink={obj.gitHubLink}/>
    });

    return <>
        {/* Skills */}
        <section id="projects" className='section'>
            <div className='my-3'>
                <h2 className='g'>Projects and skills</h2>
                <p>These are some of my main
                    skills that I have learned and I built some great projects with it.</p>
            </div>
            {renderSkills}
        </section>
        {/* Projects */}
        <section className="projects-container section">
            {renderProjects}
        </section>
    </>
}

export default Projects;